import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import UserService from "./user.service";

const BASE_URL = AdminService.getBaseUrl();
const API_SURVEY_DESIGN_URL = BASE_URL + "/api/v1/survey-design";

class NeedQuestionService {
  async copyNeedQuestions(sourceSurveyCode, targetSurveyGroupId, callback, panelApp) {
    if (typeof sourceSurveyCode != "undefined" && typeof targetSurveyGroupId != "undefined") {
      const params = new URLSearchParams();
      params.append("sourceSurveyCode", sourceSurveyCode);
      params.append("targetSurveyGroupId", targetSurveyGroupId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/copy-need-questions", params, { headers: await authHeader() })
        .then(response => {
            callback(response)
          })
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("NeedQuestionService.getNeedQuestionMetrics", error, "admin", panelApp);
          });

    }
  }
  async getNeedQuestionMetrics(surveyId, callback, panelApp) {
    if (typeof surveyId != "undefined") {
      const params = new URLSearchParams();
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-need-question-metrics", params, { headers: await authHeader() })
        .then(response => {
            callback(response)
          })
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("NeedQuestionService.getNeedQuestionMetrics", error, "admin", panelApp);
          });

    }
  }
  async getNeedQuestionSegments(surveyId, callback, panelApp) {
    if (typeof surveyId != "undefined") {
      const params = new URLSearchParams();
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-need-question-segments", params, { headers: await authHeader() })
        .then(response => {
            callback(response)
          })
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("NeedQuestionService.getNeedQuestionSegments", error, "admin", panelApp);
          });

    }
  }
  async saveMetricGroups(result, callback, panelApp) {
    if (typeof result.questionId != "undefined") {
      const params = new URLSearchParams();
      params.append("values", JSON.stringify(result.values));
      params.append("questionId", result.questionId);
      params.append("userId", UserService.getUserId());
        await axios
          .post(API_SURVEY_DESIGN_URL + "/save-metric-groups", params, { headers: await authHeader() })
          .then(response => {
            callback(response)
          })
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("NeedQuestionService.saveMetricGroups", error, "admin", panelApp);
          });

    }
  }
  async saveSegments(result, callback, panelApp) {
    if (typeof result.questionId != "undefined") {
      const params = new URLSearchParams();
      params.append("values", JSON.stringify(result.values));
      params.append("questionId", result.questionId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/save-segments", params, { headers: await authHeader() })
        .then(response => {
          callback(response)
        })
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("NeedQuestionService.saveSegments", error, "admin", panelApp);
        });
      }
    }
}

export default new NeedQuestionService();
